export default __webpack_public_path__ + "static/media/delete-icon.9791eda4.svg";